export const config = {
  title: "Kirkland's Bookkeeping, LLC | Shelby, MS",
  meta: {
    description:
      "Kirkland's Bookkeeping, LLC provides professional bookkeeping and financial management services in Shelby, MS. We help small businesses and individuals manage finances with accuracy and reliability.",
    keywords: [
      "Kirkland's Bookkeeping",
      "Bookkeeping Shelby MS",
      "Small Business Accounting",
      "Payroll Services",
      "Financial Management",
      "Tax Preparation"
    ],
    author: "Kirkland's Bookkeeping, LLC",
    canonicalUrl: "https://kirklandsbookkeepingllc.net/",
  },
  sections: {
    header: {
      businessName: "Kirkland's Bookkeeping, LLC",
    },
    sectionB: {
      heroTitle: "Your Trusted Partner in Bookkeeping",
      heroSubtitle: "Professional Bookkeeping & Financial Services in Shelby, MS",
      learnAboutText: "Learn More",
      phoneNumber: "6623605686",
      phoneLabel: "(662) 360-5686",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2165677028/photo/professional-business-woman-in-yellow-blouse-is-working-on-financial-reports-close-up-of-a.jpg?s=612x612&w=0&k=20&c=ixHVQFA81i_fM_d8EEBy0e3Fg9W1tbj-zoSg4HZHENU=",
      cardData: [
        {
          title: "Accurate Bookkeeping",
          description:
            "Maintain well-organized financial records with our accurate bookkeeping services.",
        },
        {
          title: "Payroll Management",
          description:
            "Reliable payroll services tailored for small businesses to save time and reduce errors.",
        },
        {
          title: "Financial Guidance",
          description:
            "Expert advice to help you make informed financial decisions for growth and compliance.",
        },
      ],
      description:
        "Kirkland's Bookkeeping, LLC provides trusted bookkeeping and financial management services for individuals and businesses in Shelby, MS and surrounding areas.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From bookkeeping to payroll, we offer a wide range of financial services tailored to your needs.",
      cards: [
        {
          title: "Bookkeeping",
          description:
            "Organized and up-to-date financial records to keep your business running smoothly.",
          imageSrc: "https://media.istockphoto.com/id/1145950008/photo/close-up-business-woman-using-calculator-and-laptop-for-do-math-finance-on-wooden-desk-in.jpg?s=612x612&w=0&k=20&c=hpWcHbTihUfrGAgNITaz34mHY6Z9pErYo1mHumwVExk=",
          imageAlt: "Bookkeeping Services",
        },
        {
          title: "Payroll Services",
          description:
            "Comprehensive payroll management to ensure your employees are paid accurately and on time.",
          imageSrc: "https://media.istockphoto.com/id/1330234595/photo/closeup-shot-of-an-unrecognisable-businesswoman-calculating-finances-in-an-office.jpg?s=612x612&w=0&k=20&c=dwgvBXpHuM-Jz5XCQtCtLot59CJzGm5iAlxgKm9Yr8Q=",
          imageAlt: "Payroll Services",
        },
        {
          title: "Tax Preparation",
          description:
            "Accurate and efficient tax preparation services for individuals and businesses.",
          imageSrc: "https://media.istockphoto.com/id/2165677028/photo/professional-business-woman-in-yellow-blouse-is-working-on-financial-reports-close-up-of-a.jpg?s=612x612&w=0&k=20&c=ixHVQFA81i_fM_d8EEBy0e3Fg9W1tbj-zoSg4HZHENU=",
          imageAlt: "Tax Preparation",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Financial Reporting",
        "Expense Tracking",
        "Budget Planning",
        "Small Business Consulting",
      ],
    },
    sectionD: {
      aboutTitle: "About Kirkland's Bookkeeping, LLC",
      aboutImage: {
        src: "https://img1.wsimg.com/isteam/ip/798bd50e-e6ab-48bf-8a7e-316a00fbaa67/KrystalynPicture1.JPG/:/cr=t:0.94%25,l:0%25,w:100%25,h:99.06%25/rs=w:600,h:600,cg:true/qt=q:26",
        alt: "Kirkland's Bookkeeping Team",
      },
      aboutText: [
        "Founded by Krystalyn Kirkland, Kirkland's Bookkeeping, LLC is dedicated to providing reliable and professional bookkeeping services in Shelby, MS.",
        "We aim to simplify financial management for small businesses and individuals by offering accurate record-keeping, payroll, tax preparation, and financial guidance.",
      ],
    },
    sectionE: {
      profileImage: "https://img1.wsimg.com/isteam/ip/798bd50e-e6ab-48bf-8a7e-316a00fbaa67/Wordmark%20Logo%20for%20Kirkland's%20Bookkeepi-22ce2f8.jpg/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:984,h:984",
      profileAlt: "Kirkland's Bookkeeping, LLC Logo",
      businessName: "Kirkland's Bookkeeping, LLC",
      contact: {
        phone: "6623605686",
        phoneLabel: "(662) 360-5686",
        email: "krystalynsbookkeeping@gmail.com",
        website: "https://kirklandsbookkeepingllc.net/",
        address: "Shelby, MS, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Shelby, MS, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3402.423434!2d-90.7668!3d33.9501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8629a6b5b1234567%3A0xabcdef123456789!2sShelby%2C%20MS!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;
